// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"641423e3","744":"8c65f9ad"}[chunkId] + ".js";
};